module["exports"] = ["Türkiye"];